
import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';
// import { RegPatVisit, RegPatEpisode } from '../out-pat-appointment/out-pat-reservation/out-pat-reservation.service';
import { RegPatEpisode, RegPatVisit } from '../out-pat-appointment/out-pat-reservation/out-pat-reservation.service';
import { OrderMaster } from '../../orders/order-stepper/shared/order-master';
import { OrderDetails } from '../../orders/order-stepper/shared/order-details';
import { RegPatService } from '../../pricing/reg-pat-service/reg-pat-service';
import { TherapeuticCards } from '../../registeration/contracts';
import { ApprovalRequest } from '../../approvals';
import { Order } from '../../orders/order-stepper/shared/order';
import { ApprovalRequestMaster } from '../../approvals/approvals-list/approvals-list.service';
import { EmrToothNo } from '../../medical-recored/emr-decaf/emr-decaf.service';
import { CallData } from '../../call-center/call-center-reservation';

let PriComprehensiveExaminationUrl = CONFIG.baseUrls.PriComprehensiveExamination;
let ComprehensiveRequestUrl = CONFIG.baseUrls.PriComprehensiveRequest;
let PriComprehensiveExaminPriceListUrl = CONFIG.baseUrls.PriComprehensiveExaminPriceList;
let PriComprehensiveServiceUrl = CONFIG.baseUrls.PriComprehensiveService;


@Injectable()
export class ComprehensiveExaminationOrderSetupService {
    constructor(private httpGeneralService: HttpGeneralService) { }

    getPriComprehensiveExamination(id: number) {
        return this.httpGeneralService.get(id, PriComprehensiveExaminationUrl);
    }

    getPriComprehensiveExaminPriceList(id: number) {
        return this.httpGeneralService.get(id, PriComprehensiveExaminPriceListUrl);
    }

    getPriComprehensiveServiceBycontract(contractId: number, priComprehensiveCode: any) {
        return this.httpGeneralService.getWith(`${PriComprehensiveServiceUrl}/Contract/${contractId}/${priComprehensiveCode}`);
    }

    addPriComprehensiveRequest(ComprehensiveRequest: ComprehensiveRequest) {
        return this.httpGeneralService.add(ComprehensiveRequest, `${ComprehensiveRequestUrl}/collection`);
    }

}

export interface ComprehensiveRequest {
    comprehensiveRequestMasterArray: ComprehensiveRequestMaster[],
    comprehensiveRequestDetailArray: ComprehensiveRequestDetail[],
    regPatVisit: RegPatVisit,
    orderMaster: OrderMaster;
    orderDetailArray: OrderDetails[];
    regPatServiceArray: RegPatService[];
    clincArray: RegPatService[];
    therapeuticCards: TherapeuticCards;
    regPatEpisode: RegPatEpisode;
    masterComprehensive: RegPatService;
    approvalRequestMaster: ApprovalRequestMaster;
    approvals: ApprovalRequest[];
    emrToothNo?: EmrToothNo[];
    callData?: CallData
}
export interface ComprehensiveRequestMaster {
    serial?: number
    visitSerial?: number
    comprehensiveExaminCode?: number
    priceListCode?: number
    serviceId?: number
    price?: number
    patCode?: number;
}
export interface ComprehensiveRequestDetail {
    serial?: number
    compReqMasterSerial?: number
    serviceCode?: number
    price?: number
    serviceDetectionFlag?: number
    specialtyId?: number

}
